export type DiskLinkError = 'album' | 'file' | 'not-disk';

export type ParsedDiskLink = { ok: true; publicKey: string } | { ok: false; error: DiskLinkError };

// disk.yandex.ru / .com / .by / .kz …, disk.360.yandex.ru, and the short yadi.sk.
const DISK_HOST = /^(?:disk\.(?:360\.)?yandex\.[a-z]{2,3}(?:\.[a-z]{2})?|yadi\.sk)$/;

/**
 * Reads a public Yandex Disk link. Only a folder link `/d/<key>` has an API; an album `/a/` and a single file `/i/`
 * are refused with their own reason so the screen can say what link to bring.
 *
 * `publicKey` is the folder link itself, without a sub-path, query or hash — the API takes the link as the key.
 */
export function parseDiskLink(input: string): ParsedDiskLink {
  const trimmed = input.trim();
  if (!trimmed) {
    return { ok: false, error: 'not-disk' };
  }

  let url: URL;
  try {
    url = new URL(/^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`);
  } catch {
    return { ok: false, error: 'not-disk' };
  }

  if (!DISK_HOST.test(url.hostname.toLowerCase())) {
    return { ok: false, error: 'not-disk' };
  }

  const [kind, key] = url.pathname.split('/').filter(Boolean);
  if (!key) {
    return { ok: false, error: 'not-disk' };
  }
  if (kind === 'a') {
    return { ok: false, error: 'album' };
  }
  if (kind === 'i') {
    return { ok: false, error: 'file' };
  }
  if (kind !== 'd') {
    return { ok: false, error: 'not-disk' };
  }

  return { ok: true, publicKey: `https://${url.hostname.toLowerCase()}/d/${key}` };
}
